const WinLogicConfig = {
  collection: "win_logic",
  fields: [
    "id",
    "attribute.id",
    "specification.id",
    "when_to_highlight",
    "condition_numeric",
    "condition_dropdown",
    "win_order_choices.win_order_choices",
    "win_order_choices.language",
    "condition_checkboxes",
    "condition_display",
    "compare_against",
    "match_facets",
    "compare_against_display",
    "treat_empty_values_as",
    "applicable_templates.comparison_template_type_id",
    "treat_matching_values_as"
  ],

  filter: "filter[status][_eq]=active",

  adapter: class WinLogic {
    constructor(win_logic) {
      this.id = win_logic.id;
      this.attribute = win_logic.attribute?.id || win_logic.specification?.id;
      this.when_to_highlight = win_logic.when_to_highlight;
      this.condition_numeric = win_logic.condition_numeric;
      this.condition_dropdown = win_logic.condition_dropdown;
      this.condition_checkboxes = win_logic.condition_checkboxes;
      this.condition_display = win_logic.condition_display;
      this.compare_against = win_logic.compare_against;
      this.match_facets = win_logic.match_facets || "individually";
      this.compare_against_display = win_logic.compare_against_display;
      this.treat_empty_values_as = win_logic.treat_empty_values_as || "nothing";
      this.treat_matching_values_as_win =
        win_logic.treat_matching_values_as === "win";
      this.order = win_logic.win_order_choices || [];
      this.applicable_templates = (win_logic.applicable_templates || []).map(
        (t) => t.comparison_template_type_id
      );
    }

    map(collections, maps) {
      this.attribute = maps.attributes[this.attribute];
      this.applicable_templates = this.applicable_templates.map(
        (id) => maps.comparison_template_type[id]?.key || ""
      );

      this.order = [collections.languages || collections.locales].reduce(
        (acc, next) => {
          const found_config =
            this.order.find((c) => c.language === next.id || next)
              ?.win_order_choices || [];
          const decoded_config = found_config.map((v = "") =>
            //eslint-disable-next-line
            v.replace(/\&\#44;/g, ",")
          );
          return {
            ...acc,
            [next.language]: decoded_config || []
          };
        },
        {}
      );
    }
  }
};

export default WinLogicConfig;
